import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/work-calendar/global/")({
  head: () => ({
    meta: [{ title: "全局日历 · imiker CRM" }],
  })
});
